import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import { Autoplay, FreeMode } from 'swiper/modules';
import '../../styles/SolucionesPublicitarias.css';
import logosData from '../../data/printedFormats.json';

const PrintedFormats = () => {
    return (
        <section className="printed-formats-section">
            <div className='container'>
                <div className='row justify-content-center align-items-center m-1 mb-0'>
                    <div className='col-md-6 d-flex justify-content-center mt-5'>
                        <div className='pb-2' data-aos="fade-up">
                            <h2 className="title"><span>Formatos </span> impresos</h2>
                        </div>
                    </div>
                    <div className='col-md-6 text-center mt-5' data-aos="flip-right">
                        <img src="assets/formatos-impresos.png" alt="" className='img-fluid img-filter' />
                    </div>
                </div>

                {/* Carrusel de logos */}
                <div className="logo-carousel-container d-flex justify-content-center text-center align-items-center" data-aos="fade-up" data-aos-offset="0">
                    <Swiper
                        modules={[Autoplay, FreeMode]}
                        spaceBetween={10}
                        freeMode={true}
                        autoplay={{
                            delay: 0,
                            disableOnInteraction: false
                        }}
                        speed={3000}
                        loop={true}
                        breakpoints={{
                            320: { slidesPerView: 2 },  // Móviles: 2 logos
                            480: { slidesPerView: 2 },  // Pantallas pequeñas: 3 logos
                            768: { slidesPerView: 3 },  // Tablets: 4 logos
                            1024: { slidesPerView: 4 }, // Escritorio: 5 logos
                            1280: { slidesPerView: 6 }  // Pantallas grandes: 6 logos
                        }}
                    >
                        {logosData.logos.map((logo) => (
                            <SwiperSlide key={logo.id} className="logo-slide">
                                <img src={logo.src} alt={logo.alt} data-aos="flip-left" data-aos-offset="0" className='img-fluid img-filter' />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default PrintedFormats;